import { Component, OnInit, Input } from '@angular/core';
import { SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';
import { Playable } from 'src/app/shared/directives/playable.directive';

@Component({
  selector: 'fgb-vimeo-player',
  templateUrl: './fgb-vimeo-player.component.html',
  styleUrls: ['./fgb-vimeo-player.component.scss'],
})
export class FgbVimeoPlayerComponent extends Playable implements OnInit {
  @Input() streamKey: string;
  safeUrl: SafeResourceUrl;

  constructor(private domSanitizer: DomSanitizer) {
    super();
  }

  public play(): void {
    // play with autoplay enabled
    this.safeUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(
      'https://player.vimeo.com/video/' + this.streamKey + '?autoplay=1'
    );
  }

  public pause(): void {}

  public stop(): void {}

  ngOnInit() {
    this.safeUrl = this.domSanitizer.bypassSecurityTrustResourceUrl('https://player.vimeo.com/video/' + this.streamKey);
    this.onReady.emit(); // call onReady to tell media player is ready and can now be played
  }
}
